<table class="c">
  <tr>
    <th>
      <mat-card *ngIf="notification" class="notification">{{notification}}</mat-card>
    </th>
    <th style="width: 60px;">
      <button mat-fab (click)="startButton($event)">
        <mat-icon *ngIf="!recognizing">mic</mat-icon>
        <mat-icon *ngIf="recognizing">stop</mat-icon>
      </button></th>
  </tr>
</table>
<form>
  <mat-form-field class="speech-result-width">
    <textarea matInput [value]="finalTranscript" placeholder="Speech Input Result" rows="15" disabled="true"></textarea>
  </mat-form-field>
</form>
